document.addEventListener('DOMContentLoaded', function () {
  // Bundle tier boxes and subscription toggle
  var boxes = document.querySelectorAll('.bundle-tier-box');
  var toggle = document.getElementById('bundle-subscription-toggle');
  var productForm = document.querySelector('product-form form[action="/cart/add"]');
  var atcBtn = productForm.querySelector('button.product-selector__submit.no-js-hidden');
  var productJsonElement = document.querySelector('script[data-bundle-variants-map]');
  var productJson = productJsonElement ? JSON.parse(productJsonElement.textContent) : null;
  var subFrequencyEl = document.querySelectorAll('.sub-details__delivery-frequency');
  var hasSubscription = document.querySelector('.subscription-toggle-wrapper:not(.hidden)');
  // var subDiscountOffEl = document.querySelector('.toggle-text__sub-discount > span');

  // varinat quantity to selling plan name map
  const QtyToPlanMap = {
    "1": "Deliver every month",
    "3": "Deliver every 3 months",
    "6": "Deliver every 6 months"
  }

  // Exit if required elements are missing
  if (!boxes.length || !toggle || !productForm || !productJson) {
    if (toggle) toggle.classList.add('hidden');
    return;
  };

  // Remove existing subscription item from the cart
  async function removeExistingItemsFromCart() {
    var productId = productJson.id;
    var res = await fetch('/cart.js');
    var { items } = await res.json();

    for (let i = 0; i < items.length; i++) {
      if (items[i].product_id === productId && items[i].selling_plan_allocation) {
        await removeCartItem(items[i].key);
      }
    }

    await window.upcartRefreshCart();
  }

  // Remove cart item
  async function removeCartItem(lineItemKey) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0
      })
    });
    await res.json();
  }

  // Handle add to cart
  function handleAddToCart() {
    // Clone original atc button
    var duplicateAtcBtn = atcBtn.cloneNode(true);
    duplicateAtcBtn.removeAttribute('type');
    duplicateAtcBtn.removeAttribute('name');
    duplicateAtcBtn.type = 'button';
    atcBtn.parentNode.insertBefore(duplicateAtcBtn, atcBtn);

    duplicateAtcBtn.addEventListener('click', async function() {
      duplicateAtcBtn.disabled = true;
      duplicateAtcBtn.innerText = 'Adding to cart'
      // remove existing items from the cart
      if (toggle.checked) {
        await removeExistingItemsFromCart();
      }

      atcBtn.click();
      duplicateAtcBtn.disabled = false;
      duplicateAtcBtn.innerText = 'Add to cart'
    })
  }

  // Update price display based on subscription state
  function updateDisplay() {
    var isSub = toggle.checked;

    boxes.forEach(function (box) {
      var price = box.querySelector('.current-price');
      var strike = box.querySelector('.regular-price-strike');
      var perDay = box.querySelector('.price-per-day');
      var save = box.querySelector('.saving-label');
      var discount;

      if (isSub) {
        discount = box.getAttribute('data-sub-discount');
        price.innerText = box.getAttribute('data-sub-price');
        strike.innerText = box.getAttribute('data-sub-strike');
        perDay.innerText = box.getAttribute('data-sub-perday');
        save.innerText = box.getAttribute('data-sub-save');
      } else {
        discount = box.getAttribute('data-ot-discount');
        price.innerText = box.getAttribute('data-ot-price');
        strike.innerText = box.getAttribute('data-ot-strike');
        perDay.innerText = box.getAttribute('data-ot-perday');
        save.innerText = box.getAttribute('data-ot-save');
      }

      // Show or hide strike price based on discount
      strike.style.display = discount === "0" ? 'none' : 'block';
    });
  }

  // Update sub toggle copy
  function updateSubToggleCopy(selectedBox) {
    var _selectedBox = selectedBox || document.querySelector('.bundle-tier-box.is-selected');
    subFrequencyEl.forEach(function(el) {
      el.innerText = _selectedBox.getAttribute('data-sub-freq');
    })
    // subDiscountOffEl.innerText = _selectedBox.getAttribute('data-sub-discount');
  }

  // Update selected option & quantity based on url params
  function updateOptionFromUrlParams() {
    let url = window.location.href;
    let sellingPlanId = new URLSearchParams(window.location.search).get('selling_plan');
    if (!sellingPlanId) return;

    sellingPlanId = parseInt(sellingPlanId);
    let sellingPlanName = productJson.selling_plan_groups?.flatMap(g => g.selling_plans).find(p => p.id === sellingPlanId)?.name ?? null;
    if (!sellingPlanName) return;

    let selectedQty = Object.keys(QtyToPlanMap).find(k => QtyToPlanMap[k] === sellingPlanName) ?? null;
    if (!sellingPlanName) return;

    document.querySelector(`.bundle-tier-box[data-quantity="${selectedQty}"]`)?.click();
    toggle.click();
  }

  // Set quantity from pre-selected bundle on page load
  function setQuantityOnLoad() {
    var selectedBox = document.querySelector('.bundle-tier-box.is-selected');
    if (!selectedBox) return;

    updateQuantity(selectedBox.getAttribute('data-quantity'));
  }

  // Update quantity inputs and trigger change event
  function updateQuantity(qty) {
    var allQtyInputs = productForm.querySelectorAll('input[name="quantity"]');

    allQtyInputs.forEach(function (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // update selling plan with qty change
    updateSellingPlan();
  }

  // Update subscription id of selected variant
  function updateSellingPlan() {
    var isSub = toggle.checked;
    if (!isSub) {
      setSellingPlan('');
      return;
    }

    var planId = '';
    var currentQuantity = productForm.querySelector('input[name="quantity"]').value;
  
    // variant selling plans
    var variantId = parseInt(productForm.querySelector('input[name="id"]').value, 10);
    var selectedVariantPlansId = productJson.variants.find(function (variant) {
      return variant.id === variantId;
    })?.selling_plan_allocations.map(function (allocation) {
      return allocation.selling_plan_id;
    }) || [];

    // available selling plans
    var sellingPlanGroups = productJson.selling_plan_groups ? productJson.selling_plan_groups : [];
    var validPlans = sellingPlanGroups.flatMap(function (group) {
      return group.selling_plans.map(function (plan) {
        return selectedVariantPlansId.includes(plan.id) ? { id: plan.id, name: plan.name } : null;
      }).filter(function (plan) { return plan !== null; });
    });

    // select plan id
    planId = validPlans.find(function (plan) {
      return plan.name === QtyToPlanMap[currentQuantity];
    })?.id || '';

    if (planId) {
      setSellingPlan(planId);
    } else {
      setSellingPlan('');
    }
  }

  // Create or update input for subscription id
  function setSellingPlan(planId) {
    var existingInput = productForm.querySelector('input[name="selling_plan"]');
    if (existingInput) {
      existingInput.value = planId;
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.value = planId;
      productForm.insertAdjacentElement('beforeend', input);
    }
  }

  // Toggle subscription / one-time pricing
  toggle.addEventListener('change', function () {
    updateDisplay();
    updateSellingPlan();
  });
  
  // Handle bundle tier selection
  boxes.forEach(function (box) {
    box.addEventListener('click', function () {
      boxes.forEach(function (b) {
        b.classList.remove('is-selected');
      });

      box.classList.add('is-selected');
      updateQuantity(box.getAttribute('data-quantity'));
      updateSubToggleCopy(box)
    });
  });

  // Initial setup
  setQuantityOnLoad();
  updateOptionFromUrlParams();
  updateDisplay();
  updateSubToggleCopy();
  handleAddToCart();
  if (toggle && hasSubscription) {
    toggle.click();
  }
});
